import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import ReactDOM from "react-dom";

export const USER_TITLE = [
  { name: "", label: "", tooltip: "" },
  { name: "MLLE", label: "MLLE", tooltip: "Mademoiselle" },
  { name: "MME", label: "MME", tooltip: "Madame" },
  { name: "M", label: "M", tooltip: "Monsieur" },
];
export const INTERVENTION_TYPE = [
  {
    name: "INTERVENTION",
    label: "Intervention",
    tooltip: "Créer un bon d'intervention",
  },
  {
    name: "MAINTENANCE",
    label: "Maintenance",
    tooltip: "Créer un bon de maintenance",
  },
];
export const COMPANY_OWNER = [
  { name: "ATIS_SYSTEM", label: "Atis System", tooltip: "Société Atis System" },
  { name: "EVE_FROID", label: "Eve Froid", tooltip: "Société Eve Froid" },
];
export const ADDRESS_TYPE = [
  { name: "BILL", label: "Facturation", tooltip: "Adresse de facturation" },
  {
    name: "HEAD_OFFICE",
    label: "Siège",
    tooltip: "Adresse du siège de la société",
  },
  { name: "SECTION", label: "Site", tooltip: "Adresse site" },
  { name: "OTHER", label: "Autre", tooltip: "Non précisé" },
];

export const USER_ADMIN_ROLES = [
  {
    name: "USER",
    label: "Utilisateur Client",
    tooltip: "Utilisateur du client, rattaché à une compagnie",
  },
  {
    name: "REPORTER",
    label: "Utilisateur ATIS",
    tooltip:
      "Utilisateur compagnie Atis System/Eve Froid, permet de créer des interventions",
  },
  {
    name: "ADMIN_CLIENT",
    label: "Administrateur Client",
    tooltip:
      "Permet d'administrer certaines variables clients + création d'utilisateur client",
  },
  {
    name: "ADMIN",
    label: "Administrateur",
    tooltip: "Permet d'administrer le site",
  },
];
export const USER_ROLES = [
  {
    name: "USER",
    label: "Utilisateur Client",
    tooltip: "Utilisateur du client, rattaché à une compagnie",
  },
  {
    name: "ADMIN_CLIENT",
    label: "Administrateur Client",
    tooltip:
      "Permet d'administrer certaines variables clients + création d'utilisateur client",
  },
];
export const REQUEST_STATUS = [
  {
    name: 0,
    label: "Envoyée",
    tooltip: "",
    styleClass: "mr-sm label label-warning",
  },
  {
    name: 3,
    label: "Plannifiée",
    tooltip: "",
    styleClass: "mr-sm label label-primary",
  },
  {
    name: 1,
    label: "Traitée",
    tooltip: "",
    styleClass: "mr-sm label label-success",
  },
  {
    name: 2,
    label: "Annulée",
    tooltip: "",
    styleClass: "mr-sm label label-danger",
  },
  {
    name: 4,
    label: "Anomalie",
    tooltip: "",
    styleClass: "mr-sm label label-danger",
  },
  {
    name: 5,
    label: "PDF Envoyé",
    tooltip: "",
    styleClass: "mr-sm label label-primary",
  },
  {
    name: 6,
    label: "Supprimée",
    tooltip: "",
    styleClass: "mr-sm label label-primary",
  },
  {
    name: 7,
    label: "Message laissé",
    tooltip: "",
    styleClass: "mr-sm label label-primary",
  }
  /*{name:6, label:"Supprimée", tooltip:"", styleClass:"mr-sm label label-danger"},*/
];
export const OTHER_STATUS = [
  {
    name: 0,
    label: "Envoyée",
    tooltip: "",
    styleClass: "mr-sm label label-warning",
  },
  {
    name: 3,
    label: "Plannifiée",
    tooltip: "",
    styleClass: "mr-sm label label-primary",
  },
  {
    name: 1,
    label: "Traitée",
    tooltip: "",
    styleClass: "mr-sm label label-success",
  },
  {
    name: 2,
    label: "Annulée",
    tooltip: "",
    styleClass: "mr-sm label label-danger",
  },
  {
    name: 4,
    label: "Anomalie",
    tooltip: "",
    styleClass: "mr-sm label label-danger",
  },
  /*{name:6, label:"Supprimée", tooltip:"", styleClass:"mr-sm label label-danger"},*/
];

export const REQUEST_STATUS_TXT = [
  {
    name: 0,
    label: "Envoyée",
  },
  {
    name: 3,
    label: "Plannifiée",
  },
  {
    name: 1,
    label: "Traitée",
  },
  {
    name: 2,
    label: "Annulée",
  },
  {
    name: 4,
    label: "Anomalie",
  },
  {
    name: 5, 
    label: "PDF envoyé", 
  },
  {
    name: 6, 
    label: "Supprimée", 
  },
  {
    name: 7, 
    label: "Message laissé", 
  },
];
export const ERROR_SPAN_STYLE = {
  color: "#909293",
};

//export const EMAIL_VALIDATION_REGEX = /^[-a-z0-9~!$%^&*_=+}{'?]+(\.[-a-z0-9~!$%^&*_=+}{'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|leclerc|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
export const EMAIL_VALIDATION_REGEX = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,7}$/i;

export const selectFilterMethod = (filter, row) => {
  if (filter.value === "all") {
    return true;
  }
  return row[filter.id] === filter.value;
};
export const selectFilterMethodInt = (filter, row) => {
  if (filter.value === "all") {
    return true;
  }
  return (
    Number.parseInt(row[filter.id], 10) === Number.parseInt(filter.value, 10)
  );
};
export const selectFilter = ({ filter, onChange }, items) => {
  return (
    <select
      onChange={(event) => onChange(event.target.value)}
      style={{ width: "100%" }}
      value={filter ? filter.value : "all"}
    >
      <option value="all"></option>
      {null !== items
        ? items.map(function (item, index) {
            return (
              <option key={index} value={item == null ? "" : item.name}>
                {item == null ? "" : item.label || item.name}
              </option>
            );
          })
        : ""}
    </select>
  );
};

export const focusInput = (component) => {
  if (component) {
    var domElement = ReactDOM.findDOMNode(component);
    domElement.focus();
  }
};

export const TIMELINE_EVENT_DEMANDE_TITLE = "Demande d'intervention";
export const TIMELINE_EVENT_DEMANDE_ICON = <i className="fa fa-life-ring" />;
export const TIMELINE_EVENT_DEMANDE_ICON_COLOR = "#ff902b";
export const TIMELINE_EVENT_DEMANDE_REPLY_BUTTONS = <i className="fa fa-mail-reply" />;
export const TIMELINE_EVENT_DEMANDE_PAPER_PLANE_BUTTONS = <i className="fa fa-paper-plane" />;
export const REQUEST_TYPE_DEMANDE = "DEMANDE";

export const TIMELINE_EVENT_PLANIFICATION_TITLE = "Planification de votre demande";
export const TIMELINE_EVENT_PLANIFICATION_ICON = <i className="fa fa-envelope" />;
export const TIMELINE_EVENT_PLANIFICATION_BUTTONS = <i className="fa fa-calendar-check-o" />;
export const REQUEST_TYPE_PLANIFICATION = "PLANIFICATION";

export const TIMELINE_EVENT_TITLE_INTERVENTION = "Intervention réalisée";
export const REQUEST_TYPE_INTERVENTION = "INTERVENTION";
export const TIMELINE_EVENT_TITLE_ANNULATION = "Demande annulée";
export const REQUEST_TYPE_ANNULATION = "ANNULATION";
export const TIMELINE_EVENT_TITLE_ERREUR = "Erreur lors de l'envoi";
export const REQUEST_TYPE_ERREUR = "ERREUR";

/*
const thumbsContainer = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  marginTop: 16,
};

const thumb = {
  display: "inline-flex",
  borderRadius: 2,
  border: "1px solid #eaeaea",
  marginBottom: 8,
  marginRight: 8,
  width: 100,
  height: 100,
  padding: 4,
  boxSizing: "border-box",
};

const thumbInner = {
  display: "flex",
  minWidth: 0,
  overflow: "hidden",
};

const img = {
  display: "block",
  width: "auto",
  height: "100%",
};

export function Previews(props) {
  const [files, setFiles] = useState([]);
  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop: (acceptedFiles) => {
      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
  });

  const thumbs = files.map((file) => (
    <div style={thumb} key={file.name}>
      <div style={thumbInner}>
        <img src={file.preview} style={img} />
      </div>
    </div>
  ));

  useEffect(
    () => () => {
      // Make sure to revoke the data uris to avoid memory leaks
      files.forEach((file) => URL.revokeObjectURL(file.preview));
    },
    [files]
  );

  return (
    <section className="container">
      <div {...getRootProps({ className: "dropzone" })}>
        <input {...getInputProps()} />
        <p>Déposer des fichiers ici ou cliquer sur le bouton</p>
      </div>
      <aside style={thumbsContainer}>{thumbs}</aside>
    </section>
  );
}*/



// WEBPACK FOOTER //
// ./src/components/UI/UIConstants.js